import { render, staticRenderFns } from "./COverlay.vue?vue&type=template&id=5cdaa239&scoped=true&"
import script from "./COverlay.vue?vue&type=script&lang=ts&"
export * from "./COverlay.vue?vue&type=script&lang=ts&"
import style0 from "./COverlay.vue?vue&type=style&index=0&id=5cdaa239&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdaa239",
  null
  
)

export default component.exports